import { Injectable } from '@angular/core';
import { NzMessageService, NzMessageDataOptions } from 'ng-zorro-antd';

export const MESSAGE_SERVICE = {
  types: {
    info: 'info',
    success: 'success',
    error: 'error',
    warning: 'warning'
  }
}

export interface IMessageOptions extends NzMessageDataOptions {
  content: string,
  type?: string
}

@Injectable()
export class MessageService {
  constructor(
    private nzMessageService: NzMessageService
  ) { }

  initOptions(options?: IMessageOptions): IMessageOptions {
    if (!options) {
      options = <IMessageOptions>{};
    }

    //Type
    if (!options.type) {
      options.type = MESSAGE_SERVICE.types.info;
    }

    //Content
    if (!options.content) {
      options.content = '';
    }

    return options;
  }

  presentSuccess(options?: IMessageOptions) {
    options = this.initOptions(options);
    options.type = MESSAGE_SERVICE.types.success;
    this.present(options);
  }

  presentError(options?: IMessageOptions) {
    options = this.initOptions(options);
    options.type = MESSAGE_SERVICE.types.error;
    this.present(options);
  }

  presentWarning(options?: IMessageOptions) {
    options = this.initOptions(options);
    options.type = MESSAGE_SERVICE.types.warning;
    this.present(options);
  }

  present(options?: IMessageOptions) {
    options = this.initOptions(options);

    switch (options.type) {
      //Success
      case MESSAGE_SERVICE.types.success:
        this.nzMessageService.success(options.content, options);
        break;
      //Error
      case MESSAGE_SERVICE.types.error:
        this.nzMessageService.error(options.content, options);
        break;
      //Warning
      case MESSAGE_SERVICE.types.warning:
        this.nzMessageService.warning(options.content, options);
        break;
      //Info
      default:
        this.nzMessageService.info(options.content, options);
        break;
    }
  }
}